export { GenerateForeignWorkerDeclarationComponent } from './generate-foreign-worker-declaration.component';
export { GenerateForeignWorkerDeclarationModalData } from './generate-foreign-worker-declaration-modal-data';